import React from "react";
import { Box } from "theme-ui";
import { ActionBanner } from "../molecules";
import { navigate } from "@reach/router";
import { getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";
import { colors } from "../../styles/theme";

const ActionBannerSection = () => {
  const { actionBannerImage } = useStaticQuery(graphql`
    query {
      actionBannerImage: file(
        relativePath: { eq: "homeV1/ActionBannerHomeIN.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
      }
    }
  `);
  const image = getImage(actionBannerImage);

  return (
    <Box>
      <ActionBanner
        variant="BodyBannerV8"
        theme="primary"
        image={image}
        imageAlt="India Home Page"
        title={
          <>
            Evaluating our pricing?
            <br />
            We’ll take the price challenge!
          </>
        }
        desc="Our customers endorse we offer exceptional software and service at unchallenged prices. Our costs per license are the lowest in our category."
        primaryBtnLabel="Plans and pricing"
        primaryBtnId="home_plans_and_pricing_in_btn"
        onPrimaryButtonClick={() => navigate("/pricing/?gc_source=home")}
        secondaryBtnLabel="Discuss pricing"
        secondaryBtnId="home_discuss_pricing_in_btn"
        onSecondaryButtonClick={() =>
          navigate("/demo/?gc_source=home&ac_form_tag=AF_DEMO_HOME")
        }
        testimonial="true"
        customStyles={{
          mb: 0,
        }}
      />
    </Box>
  );
};

export default ActionBannerSection;
